"use client";

import { useEffect, useState } from "react";

declare global {
	interface Window {
		rewardful: (event: string, callback: () => void) => void;
		Rewardful: {
			referral: string | null;
		};
	}
}

export function useRewardful() {
	const [referralId, setReferralId] = useState<string | null>(null);

	useEffect(() => {
		// Wait for Rewardful to be ready
		if (typeof window !== "undefined" && window.rewardful) {
			window.rewardful("ready", () => {
				if (window.Rewardful?.referral) {
					setReferralId(window.Rewardful.referral);
				}
			});
		}
	}, []);

	return { referralId };
}
